module.exports = __webpack_public_path__ + "static/img/huiyuan.e4b11dce.png";